// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__AU6sr","insightsList":"newBusinessInsightsMenu_insightsList__1ohO5","active":"newBusinessInsightsMenu_active__8-uGB"};